import {
  List
} from '@material-tailwind/react'

export const ReportList = ({ children }) => {
  return (
    <List className='gap-3 p-0'>
      {children}
    </List >
  )
}
